export default __webpack_public_path__ + "static/media/logo.79dd2485.svg";